import { z } from 'zod'

import { labelAndValue, paginationSchema, sortingSchema } from '@/utils/zod'

import { SECTION_STATUSES } from '../constants/section-status'

export const sectionListFiltersSchema = z.object({
  ids: z.array(labelAndValue()).optional(),
  courseIds: z.array(labelAndValue()).optional(),
  curriculumIds: z.array(labelAndValue()).optional(),
  statuses: z.array(z.enum(SECTION_STATUSES)).optional(),
  ...paginationSchema.shape,
  ...sortingSchema.shape
})

export type SectionListFilters = z.infer<typeof sectionListFiltersSchema>

export type SectionListFiltersKey = keyof SectionListFilters
